import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isToday, isYesterday, format } from 'date-fns';

import { stj } from '@chronos/time-util';
import * as S from './styled';

const TimeLine = ({ date, secondsByDate, secondsByWeek }) => {
  const [dateHumanFormat, secondsByDateHumanFormat, secondsByWeekHumanFormat] =
    useMemo(() => {
      let dateFormatted = format(date, 'E, d LLL');
      if (isToday(date)) {
        dateFormatted = 'Today';
      }
      if (isYesterday(date)) {
        dateFormatted = 'Yesterday';
      }
      return [dateFormatted, stj(secondsByDate), stj(secondsByWeek)];
    }, [date, secondsByDate, secondsByWeek]);

  return (
    <S.Timeline>
      <S.DayPoint>
        <div>{dateHumanFormat}</div>
        {secondsByDate && (
          <S.SecondsByDate>- {secondsByDateHumanFormat}</S.SecondsByDate>
        )}
      </S.DayPoint>
      {secondsByWeek && (
        <S.WeekPoint>
          <S.SecondsByWeek>- {secondsByWeekHumanFormat}</S.SecondsByWeek>
          <div>Week total</div>
        </S.WeekPoint>
      )}
    </S.Timeline>
  );
};

TimeLine.propTypes = {
  date: PropTypes.instanceOf(Date),
  secondsByDate: PropTypes.number,
  secondsByWeek: PropTypes.number,
};

export default TimeLine;
